import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';
import type { ProductModificationStatus } from 'state/productModificationForm';

type OwnProps = {
  canApply: boolean;
  onApply: () => void;
  onReload: () => void;
  status: ProductModificationStatus;
  isReady: boolean;
};

export const ProductModificationButtons: FC<OwnProps> = ({ canApply, onApply, onReload, status, isReady }) => {
  const isDisabled = status === 'INITIALIZED';
  const isApplyButtonDisabled = !canApply || isReady === false;
  const showApplyButton = status === 'INITIALIZED';
  const showReloadButton = status === 'SUCCESS' || status === 'FAILED';

  return (
    <div className="d-flex flex-column mx-3 mb-3" data-e2e="product-modification-actions">
      {showApplyButton && (
        <button
          key="applyProductModification"
          data-e2e="applyProductModification"
          disabled={isApplyButtonDisabled}
          className="btn btn-xl btn-info m-1"
          onClick={onApply}
        >
          <FormattedMessage id="productModification.button.apply" defaultMessage="Apply" />
        </button>
      )}

      {showReloadButton && (
        <button
          key="reloadProductModification"
          data-e2e="reload-product-modification"
          disabled={isDisabled}
          className="btn btn-xl btn-primary m-1"
          onClick={onReload}
        >
          <FormattedMessage id="productModification.button.reload" defaultMessage="Reload" />
        </button>
      )}
    </div>
  );
};
